import React from "react";
import { NavLink } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import Logo from "../../assets/Logo.png";
import { useTranslation } from "react-i18next";

type Props = {};

const SidebarAdmin: React.FC = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="w-[240px] bg-sidebarcolor min-h-screen">
      <div className="flex flex-col items-center pt-4">
        <div className="w-full pl-10">
          <a href="#" onClick={() => window.location.reload()}>
            <img src={Logo} alt="Logo" />
          </a>
        </div>
        <div className="flex flex-col items-center w-full pt-10">
          <NavLink
            to="/admin-panel/add-new-food"
            className={({ isActive }) =>
              isActive
                ? "bg-customOrange w-full text-white py-3 pl-10 text-sm"
                : "w-full text-white py-3 pl-10 text-sm"
            }
          >
            <div className="flex items-center gap-2">
              <RxDashboard />
              {t("sidebarAdmin.addNewFood")}
            </div>
          </NavLink>
          <NavLink
            to="/admin-panel/allposts"
            className={({ isActive }) =>
              isActive
                ? "bg-customOrange w-full text-white py-3 pl-10 text-sm"
                : "w-full text-white py-3 pl-10 text-sm"
            }
          >
            <div className="flex items-center gap-2">
              <RxDashboard />
              {t("sidebarAdmin.allPosts")}
            </div>
          </NavLink>
          <NavLink
            to="/admin-panel/review-request"
            className={({ isActive }) =>
              isActive
                ? "bg-customOrange w-full text-white py-3 pl-10 text-sm"
                : "w-full text-white py-3 pl-10 text-sm"
            }
          >
            <div className="flex items-center gap-2">
              <RxDashboard />
              {t("sidebarAdmin.reviewRequest")}
            </div>
          </NavLink>
          <NavLink
            to="/admin-panel/category"
            className={({ isActive }) =>
              isActive
                ? "bg-customOrange w-full text-white py-3 pl-10 text-sm"
                : "w-full text-white py-3 pl-10 text-sm"
            }
          >
            <div className="flex items-center gap-2">
              <RxDashboard />
              {t("sidebarAdmin.category")}
            </div>
          </NavLink>
          <NavLink
            to="/admin-panel/allusers"
            className={({ isActive }) =>
              isActive
                ? "bg-customOrange w-full text-white py-3 pl-10 text-sm"
                : "w-full text-white py-3 pl-10 text-sm"
            }
          >
            <div className="flex items-center gap-2">
              <RxDashboard />
              {t("sidebarAdmin.allUsers")}
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SidebarAdmin;
